// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "509e7a571c5ccc3a695813699fdbeb82" + ".css";
};